<template>
    <div class="vue-need-bootstrap h100">
        <div class="d-flex justify-content-center w-100 h-100 overflow-auto">
            <div class="d-flex flex-column h-100 w-100" :class="{ 'mb-3': breadcrumbItems.length }">
                <b-breadcrumb v-if="breadcrumbItems.length" :items="breadcrumbItems" />
                <c-loader v-model="loader.value" :text="loader.text" />
                <div class="app-container mt-3 d-flex flex-grow-1">
                    <transition name="fade" mode="out-in">
                        <router-view />
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<!-- TODO: transform this wrapper into app.vue -->
<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';
import store from '@/store';
import CLoader from '@/components/shared/CLoader.vue';

interface BreadcrumbItem {
    name: string;
    href: string;
    link?: string;
}

const route = useRoute();

const breadcrumbItems = computed(() => {
    const breadcrumbs: BreadcrumbItem[] = route.meta?.breadcrumb || [];
    return breadcrumbs.map((b) => ({
        to: b.link,
        text: b.name,
        href: b.href
    }));
});

const loader = computed(() => {
    const state = store.state.loader;
    return {
        value: state.active,
        text: state.text
    };
});
</script>
